import styles from './index.module.less'
// import Icon from '@ant-design/icons'
import {Button, Col, ConfigProvider, Form, Row, Skeleton} from 'antd'
import {useCountDown, useDebounceEffect, useSetState, useUpdateEffect} from 'ahooks'
import {debounce} from 'lodash-es'
import animationQueue, {AnimateView, VIEW_POSITION} from './modules/animationQueueControl'
import OkButton from '@/pages/login/modules/OkButton'
import useUser from '@/hooks/useUser'
import {forwardRef, useEffect, useImperativeHandle, useRef} from 'react'
import Icon from '@ant-design/icons'
import {MainLogo, PasswordHiddenIcon, PasswordVisibleIcon,} from '@/components/icons.tsx'
import {ExplainInput} from '@/pages/login/ExplainInput'
import {sendLoginVerifyCode} from '@/services/user.ts'
import useValidate from '@/hooks/useValidate.ts'

const LoginAccountForm = forwardRef((props: any, ref) => {
  const { id, onFinish, titleLogoImg, onSetFormData, loading } = props

  const _id = id || 'account_form'
  const { isPlatform } = useUser()
  const valuesRef = useRef({workNumber:"13363601354"})
  const userNameRef = useRef<any>()

  const [state, setState] = useSetState({
    passwordVisible: false,
    loading: false,
    error: {},
    loginType: 'ACCOUNT', // ACCOUNT | MOBILE
    targetDate: 0, // 倒计时
  })

  useImperativeHandle(ref, () => ({
    reset: () => {
      form.resetFields()
      valuesRef.current = {}
    },
  }))

  useDebounceEffect(
    () => {
      animationQueue.insert(new AnimateView({ id: _id, position: VIEW_POSITION.show }), 0)
    },
    [],
    { wait: 200 }
  )

  useEffect(() => {
    return () => {
      animationQueue.reset()
    }
  }, []);

  const [validateHelper] = useValidate()
  const [countdown] = useCountDown({
    targetDate: state.targetDate,
    onEnd: () => {
      // alert('End of the time')
    },
  })

  const [form] = Form.useForm()

  // const handleFinish = () => {}

  const handleFinish = values => {
    const res = onFinish?.(values, state.loginType)
    if (res instanceof Promise) {
      setState({ loading: true })
      res.then(() => {}).finally(() => setState({ loading: false }))
    }
  }

  const handleSubmit = debounce(() => {
    // form.validateFields().then(handleFinish)
    const fields =
      state.loginType === 'ACCOUNT' ? ['workNumber', 'password'] : ['workNumber', 'code']

    const errors: any[] = []
    fields.forEach(field => {
      if (!valuesRef.current[field]) {
        state.error[field] = 'required'
        errors.push(field)
      }
    })
    setState({ error: state.error })
    if (!errors.length) {
      handleFinish(valuesRef.current)
    }
  }, 200)

  const handleForgetPassword = () => {
    // viewQueue.slideOut(_id)
    // viewQueue.slideIn('reset_step1')
    animationQueue.next()
    onSetFormData?.({ workerNumber: form.getFieldValue('workNumber') })
  }

  const handleFiledChange = (val: string, field: string) => {
    if (val === '') {
      state.error[field] = 'required'
    }

    valuesRef.current[field] = val
    state.error[field] = val === '' ? 'required' : false
    setState({ error: state.error })
    // console.log('handleFiledChange', val, field)
  }

  // const onFinishFailed = (errorInfo: any) => {
  //   console.log('Failed:', errorInfo)
  // }

  const togglePwdVisible = () => {
    setState({
      passwordVisible: !state.passwordVisible,
    })
  }

  useUpdateEffect(() => {
    if (state.loginType === 'MOBILE') {
      userNameRef.current.validate?.()
    } else {
      userNameRef.current.resetError?.()
    }
  }, [state.loginType])

  const handleToggleType = () => {
    const loginType = state.loginType === 'ACCOUNT' ? 'MOBILE' : 'ACCOUNT'
    if (loginType === 'MOBILE') {
      valuesRef.current['workNumber'] = valuesRef.current['workNumber']?.slice?.(0, 11)
    }

    setState({ loginType })
  }

  const handleSendCode = async () => {
    return userNameRef.current
      .validate()
      .then(() => sendLoginVerifyCode(valuesRef.current['workNumber']))
      .then(() => {
        setState({ targetDate: Date.now() + 60000 })
      })
  }

  return (
    <div className={styles.accountForm} id={_id}>
      <div
        className={styles.loginTitle}
        style={{ minHeight: 92, position: 'relative', zIndex: 10 }}
      >
        <Row align="middle" justify="center">
          <Col>
            {titleLogoImg ? (
              <img src={titleLogoImg} alt="" style={{ maxHeight: 60, maxWidth: '100%' }} />
            ) : null}
          </Col>
        </Row>

        {!titleLogoImg ? (
          <div>
            <div style={{ fontSize: 45, lineHeight: 0 }}>
              <MainLogo />
            </div>

            <div className={styles.loginDefaultText}>欢迎使用积木云装</div>
          </div>
        ) : null}
      </div>

      <div className={styles.inputLabel}>{{ ACCOUNT: '账号', MOBILE: '手机号' }[state.loginType]}</div>
      <ExplainInput
        ref={userNameRef}
        name="workNumber"
        placeholder={{ ACCOUNT: '请输入您的账号', MOBILE: '请输入您的手机号' }[state.loginType]}
        error={state.error}
        onChange={handleFiledChange}
        rules={state.loginType === 'MOBILE' ? [validateHelper.phoneValidate] : []}
        maxLength={state.loginType === 'MOBILE' ? 11 : null}
        value={valuesRef.current['workNumber'] || ''}
      />

      {state.loginType === 'ACCOUNT' ? (
        <>
          <div className={styles.inputLabel}>密码</div>
          <ExplainInput
            name="password"
            placeholder="请输入密码"
            error={state.error}
            style={{ marginBottom: 2 }}
            onChange={handleFiledChange}
            type={state.passwordVisible ? '' : 'password'}
            onPressEnter={handleSubmit}
            suffix={
              <div className={styles.inputIconWrap} onClick={togglePwdVisible}>
                {state.passwordVisible ? (
                  <Icon component={PasswordVisibleIcon} />
                ) : (
                  <Icon component={PasswordHiddenIcon} />
                )}
              </div>
            }
          />
        </>
      ) : null}

      {state.loginType === 'MOBILE' ? (
        <>
          <div className={styles.inputLabel}>验证码</div>
          <Row gutter={12} style={{ marginBottom: 0 }}>
            <Col span={15}>
              <ExplainInput
                name="code"
                placeholder="请输入验证码"
                error={state.error}
                style={{ marginBottom: 2, paddingRight: 0 }}
                onChange={handleFiledChange}
                onPressEnter={handleSubmit}
                value={valuesRef.current['code'] || ''}
                suffix={<div className={styles.inputIconWrap} onClick={togglePwdVisible}></div>}
              />
            </Col>
            <Col span={9}>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultBg: '#f1f1f1',
                    },
                  },
                }}
              >
                <Button
                  // type="text"
                  block
                  onClick={handleSendCode}
                  style={{
                    height: 46,
                    border: 0,
                  }}
                  disabled={countdown !== 0}
                >
                  {countdown === 0 ? '获取验证码' : `${Math.round(countdown / 1000)}s`}
                </Button>
              </ConfigProvider>
            </Col>
          </Row>
        </>
      ) : null}

      <Row align="middle" style={{ paddingTop: '8px' }} justify="space-between">
        <Col>
          <Button type="link" size="small" onClick={handleToggleType}>
            {state.loginType === 'ACCOUNT' ? '手机验证码登录' : '账号密码登录'}
          </Button>
        </Col>
        <Col>
          {isPlatform() ? null : (
            <div style={{ textAlign: 'right' }}>
              <Button
                type="text"
                size="small"
                onClick={handleForgetPassword}
                style={{ color: '#999' }}
              >
                忘记密码？
              </Button>
            </div>
          )}
        </Col>
      </Row>

      {loading ? (
        <div style={{ marginTop: 32 }}>
          <Skeleton.Button active block size="large" />
        </div>
      ) : (
        <OkButton loading={state.loading} onClick={handleSubmit} />
      )}
    </div>
  )
})
export default LoginAccountForm
